import doctorProfile from '../../images/defaultprofile.png';
const configurations = {
    // defaultImage: `${process.env.REACT_APP_SERVER}/defaultIcons/profile.png`,
    defaultImage: doctorProfile,
    API_SERVER: process.env.REACT_APP_API_SERVER
};

export default configurations;
